exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".correct-answer---3NiQy{border-radius:20px;border:1px solid #bcedbd;margin-top:20px;overflow:hidden}.correct-answer---3NiQy .correct-answer-text---2MhDp{background-color:#f6fef4;text-align:center;border-radius:20px 20px 0 0;padding:10px 0}.correct-answer---3NiQy .correct-answer-container---1p-HG{margin:5px;padding:5px;overflow:auto}.correct-answer---3NiQy *[data-type=\"default-content\"]{display:none}.dis-rat---3WODE{border-radius:20px;border:1px solid #bcedbd;margin-top:20px}.dis-rat---3WODE .dis-rat-container---2nUr9{padding:20px 10px}.dis-rat---3WODE .dis-rat-container---2nUr9 [data-type=qtc-template-wrapper] [data-type=question-description]{line-height:1}", ""]);

// exports
exports.locals = {
	"correct-answer": "correct-answer---3NiQy",
	"correct-answer-text": "correct-answer-text---2MhDp",
	"correct-answer-container": "correct-answer-container---1p-HG",
	"dis-rat": "dis-rat---3WODE",
	"dis-rat-container": "dis-rat-container---2nUr9"
};